@if (vm.activeStep) {
  @switch (vm.activeStep.fieldType) {
    @case ('SEARCH') {
      <app-text-search
        [ngModel]="vm.formValue?.[vm.activeStep.name]"
        [placeHolder]="vm.activeStep.placeholder"
        [label]="vm.activeStep.title"
        [name]="vm.activeStep.name"
        (loadingData)="loadingData.emit($event)"
      ></app-text-search>
    }

    @case ('SELECT') {
      <app-text-search
        [ngModel]="vm.formValue?.[vm.activeStep.name]"
        [label]="vm.activeStep.title"
        [name]="vm.activeStep.name"
        (loadingData)="loadingData.emit($event)"
      ></app-text-search>
    }

    @case ('RADIO') {
      <section class="flex gap-12 w-full">
        <app-radio-button
          style="flex: 1"
          variant="blue"
          [ngModel]="vm.formValue?.[vm.activeStep.name]"
          [name]="vm.activeStep.name"
          [index]="0"
          [includeResetOption]="false"
          [optionValue]="false"
        >
          No
        </app-radio-button>
        <app-radio-button
          style="flex: 1"
          variant="blue"
          [ngModel]="vm.formValue?.[vm.activeStep.name]"
          [name]="vm.activeStep.name"
          [index]="1"
          [includeResetOption]="false"
          [optionValue]="true"
        >
          Yes
        </app-radio-button>
      </section>
    }

    @case ('DATE') {
      <app-calendar-picker
        [ngModel]="vm.formValue?.[vm.activeStep.name]"
        [name]="vm.activeStep.name"
        [showTodaySelection]="true"
        [onlyShowActiveDatesInCurrentMonth]="true"
        [showShortenedDays]="true"
        [maxDate]="todaysDate"
      ></app-calendar-picker>
    }

    @case ('TEXTBOX') {
      <app-text-area
        [dataLabel]="vm.activeStep.name"
        [ngModel]="vm.formValue?.[vm.activeStep.name]"
        [name]="vm.activeStep.name"
        dataTestId="response-textarea"
      >
      </app-text-area>
    }

    @default {
      <pre>{{ vm.activeStep | json }}</pre>
    }
  }

  @if (!vm.formValid && vm.formSubmitted) {
    <section class="error mt-8">
      <i class="fa-light fa-circle-exclamation"></i>
      <p class="body">{{ validationMessage }}</p>
    </section>
  }
}
